import { defineMessages } from 'react-intl'

export const SORT_BY = defineMessages({
  feature: {
    id: 'feature',
    defaultMessage: 'Featured',
    value: '-shop_rating',
  },
  cheapest: {
    id: 'cheapest',
    defaultMessage: 'Cheapest',
    value: 'minimum_price',
  },
  guest_rating: {
    id: 'guest_rating',
    defaultMessage: 'Guest ratings',
    value: '-rating',
  },
})

export const GROUP_BY = defineMessages({
  boats: {
    id: 'boats',
    defaultMessage: 'Boats',
    value: 'boats',
    icon: 'liveaboard-icon',
  },
  dates: {
    id: 'departure_dates',
    defaultMessage: 'Departure dates',
    value: 'dates',
    icon: 'calendar-icon',
  },
})

export const filtersKeys = [
  'departure_date',
  'departure_date_custom',
  'routes',
  'marine_life_critters',
  'marine_life_group_critters',
  'experience',
  'diving_intensity',
  'rating',
  'parameters',
  'themes',
  'harbours',
  'duration',
  'price',
  'is_promotion',
  'sponsors',
  'view',
  'ordering',
  'shop',
  'tag',
  'shop_id',
  'organiserTitle',
  'liveaboard_size',
  'cabin_occupancy',
]

export const filtersToClean = [
  'routes',
  'marine_life_critters',
  'marine_life_group_critters',
  'experience',
  'diving_intensity',
  'rating',
  'parameters',
  'themes',
  'harbours',
  'duration',
  'price',
  'is_promotion',
  'sponsors',
  'tag',
  'shop_id',
  'organiserTitle',
  'liveaboard_size',
  'cabin_occupancy',
  'total_number_of_rooms_max',
  'total_number_of_rooms_min',
]
